import {
  ReferenceControl,
  ReferenceValue,
} from '../../../../../../types/types';

export const getReferenceParamsString = (
  control: ReferenceControl,
  offset,
  labelFilter,
  valueFilter: ReferenceValue | null,
  defaultFilterQuery: string | null,
  labelItem: string,
  // Omit to skip the limit param (e.g. value-resolution fetches that must return all selected items)
  limit?: number
) => {
  const items = [control.idItem];
  if (control.labelItem) {
    items.push(control.labelItem);
  }
  // Include limit only when provided; value-resolution fetches omit it to avoid page-size truncation
  const limitPart = limit !== undefined ? `&limit=${limit}` : '';
  let paramString = `items=${items.toString()}${limitPart}&sort=${labelItem}`;
  if (offset) {
    paramString = `${paramString}&offset=${offset}`;
  }
  if (defaultFilterQuery) {
    paramString = `${paramString}&${defaultFilterQuery}`;
  }
  if (labelFilter) {
    paramString = `${paramString}&filter[${labelItem}][contains]=${labelFilter}`;
  }
  if (valueFilter) {
    paramString = `${paramString}&filter[${control.idItem}][in]=${valueFilter}`;
  }
  return paramString;
};
